// extracted by mini-css-extract-plugin
export default {"three-dots-loader":"loader_three-dots-loader__A27r8","grow":"loader_grow__D+qWP","dark-loader":"loader_dark-loader__Yl4Hq"};